import qrcode from 'qrcode-generator';

// Generated on the device. No profile URL is sent to an external QR service.
export function createProfileQR(url) {
  if (!url || !/^https:\/\/www\.trade-log\.co\.uk\/(?:u\/[a-z0-9]+(?:-[a-z0-9]+)*|welcome(?:#workspace)?)$/.test(url)) return null;
  const code = qrcode(0, 'M');
  code.addData(url, 'Byte'); code.make();
  const count = code.getModuleCount();
  const modules = Array.from({ length: count }, (_, row) => Array.from({ length: count }, (_, col) => code.isDark(row, col)));
  const paths = [];
  modules.forEach((row, y) => {
    for (let x = 0; x < count; x++) if (row[x]) {
      const start = x; while (row[x + 1]) x++;
      paths.push(`M${start + 4},${y + 4}h${x - start + 1}v1h-${x - start + 1}z`);
    }
  });
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${count + 8} ${count + 8}" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="#fff"/><path fill="#08180e" d="${paths.join('')}"/></svg>`;
  return { url, count, modules, image: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}` };
}

export function drawProfileQR(ctx, code, x, y, size, pixelScale = 1) {
  if (!code) return;
  const cell = Math.floor(size * pixelScale / (code.count + 8)) / pixelScale;
  const left = Math.round((x + (size - cell * (code.count + 8)) / 2) * pixelScale) / pixelScale;
  const top = Math.round((y + (size - cell * (code.count + 8)) / 2) * pixelScale) / pixelScale;
  ctx.fillStyle = '#ffffff'; ctx.fillRect(x, y, size, size);
  ctx.fillStyle = '#08180e';
  code.modules.forEach((row, rowIndex) => {
    for (let col = 0; col < code.count; col++) if (row[col]) {
      const start = col; while (row[col + 1]) col++;
      ctx.fillRect(left + (start + 4) * cell, top + (rowIndex + 4) * cell, (col - start + 1) * cell, cell);
    }
  });
}
